import { QueryClient } from "@tanstack/react-query";
import { getApiErrorCode, getApiErrorMessage } from "../../utils/apiError";

export const ANALYTICS_STALE_TIME = 5 * 60_000;
export const ANDAMENTO_REFETCH_INTERVAL = 30_000;

export type ApiError = { status: number | null; code: string | null; message: string; extra: Record<string, unknown> };

const statusOf = (error: unknown): number | null => {
  const s = (error as { response?: { status?: unknown } })?.response?.status;
  return typeof s === "number" ? s : null;
};

export function toApiError(error: unknown, fallback: string): ApiError {
  const data = ((error as { response?: { data?: unknown } })?.response?.data ?? {}) as Record<string, unknown>;
  const { code: _code, message: _message, ...extra } = data;
  return { status: statusOf(error), code: getApiErrorCode(error), message: getApiErrorMessage(error, fallback), extra };
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          const s = statusOf(error);
          return failureCount < 1 && !(s !== null && s >= 400 && s < 500);
        },
      },
      mutations: { retry: false },
    },
  });
}

export const queryClient = createQueryClient();
